import logotyp from '../../assets/img/logotyp_ci_prs_32px.png'

const Footer = () => {
    return (
        <footer className='d-flex justify-content-end'>
            <div className='mx-4 p-2 pb-d-flex text-left align-items-center gap-3'>
                <strong>Realizacja: </strong>{' '}
                <img alt='logo CI-PRS' src={logotyp}/>
            </div>
        </footer>
    )
}

export default Footer
